export default __webpack_public_path__ + "static/media/logo.7e271e05.svg";